import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"

export default function PromoBanner() {
    const searchParams = new URLSearchParams(window.location.search)
    const [loading, setLoading] = useState(true)
    const [list, setlist] = useState({})
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [value, setValue] = useState({})

    const [file, setFile] = useState(null)
    const [preview, setpreview] = useState(null)
    const handleFileChange = (event, id) => {
        let reader = new FileReader();
        let profile = event.target.files[0];
        if (profile.type.startsWith("image/")) {
            reader.onloadend = () => {
                if (profile.size <= 10000000) {
                    setpreview(reader.result)
                    setFile(profile)
                } else {
                    Api.Alert("Max file size 10MB", "error")
                }
            };
        } else {
            Api.Alert("Uploaded file is not a valid image. Only JPG, PNG and GIF files are allowed. ", "error")
        }

        if (!_.isUndefined(profile)) {
            reader.readAsDataURL(profile);
        }
    }

    const getList = () => {
        Api.GetApi(endPoints.PROMOBANNER).then(res => {
            setLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setlist(res.data.data || {})
                    handleClose()
                }
            }
        })
    }

    const handleClose = () => {
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
        setpreview(null)
        setFile(null)
        setValue({})
    }

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new slide"
        })
    }
    const handleChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value })
    }
    const handleSubmit = () => {
        if (!value.heading || !value.offerAmount || !value.originalAmount) {
            return Api.Alert("Please fill all required fields", "error")
        }
        let data = {
            "heading": value.heading || "",
            "offerAmount": value.offerAmount || "",
            "originalAmount": value.originalAmount || "",
        }

        if (modal.type === "add") {
            Api.PostApi(endPoints.PROMOBANNER, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Added successfully!", "success")
                        getList()
                    }
                }
            })
        } else {
            Api.PutApi(`${endPoints.PROMOBANNER}/${modal.data._id}`, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Updated successfully!", "success")
                        getList()
                    }
                }
            })
        }
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            Api.DeleteApi(`${endPoints.PROMOBANNER}/${modal.data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    Api.Alert(res.data.data, "success")
                    getList()
                }
            })
        }
    }

    const updateFn = (data) => {
        Api.PostApi(`${endPoints.PROMOBANNER}/setting`, data).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    Api.Alert("Updated successfully!", "success")
                    getList()
                }
            }
        })
    }
    const updateImage = () => {
        let data = new FormData();
        if (file) {
            data.append("promo_banner_image", file)
        } else {
            if (list.setting?.promoImage) {
                data.append("promo_banner_image", list.setting?.promoImage)
            } else {
                return Api.Alert('Please select image', "error")
            }
        }
        data.append("isActive", list.setting.isActive)
        updateFn(data)
    }
    const toggleActiveState = (e) => {
        let data = new FormData();
        if (list.setting?.promoImage) {
            data.append("promo_banner_image", list.setting?.promoImage)
        }
        data.append("isActive", e.target.checked)
        updateFn(data)
    }

    const showModal = (data, type) => {
        if (type === "edit") {
            setValue({ ...value, ...data })
        }
        setModal({
            ...modal,
            data: data,
            show: true,
            type: type,
        })
    }
    console.log("value", value)

    useEffect(() => {
        getList()
    }, [])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Promo Banners</h1>
                        {list.list && list.list.length < 3 ?
                            <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                            : null
                        }
                    </div>
                    <div className="card">
                        <div className="card-body ">
                            <div
                                className="inline-container carousel_slider_container"
                            >
                                <div className='carousel_slide'>
                                    <div className='imageBtns'>
                                        <Form.Check
                                            className='mb-0'
                                            type="switch"
                                            name="isActive"
                                            checked={list.setting?.isActive}
                                            onChange={toggleActiveState}
                                        />
                                    </div>
                                    <div className='carousel_slider p-3'>
                                        <div className=''>
                                            <div style={{ maxWidth: 150, position: "relative" }}>
                                                <div className='img_upload d-block'>
                                                    <img src={preview || list.setting?.promoImage} alt='' className='img-fluid' />
                                                    <div className='imageBtns' style={{ pointerEvents: "none" }}>
                                                        <span className="btn btn-sm btn-success" title="Remove image">
                                                            <Icon.PencilFill />
                                                        </span>
                                                    </div>
                                                    <input type='file' className="hidden" accept="image/png, image/gif, image/jpeg, image/svg, image/webp" onChange={handleFileChange} />
                                                </div>
                                                {file ?
                                                    <div className='text-center mt-3'>
                                                        <button className='btn btn-sm btn-primary' onClick={updateImage}>Update</button>
                                                    </div> : null

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {list.list && list.list.length > 0 ?
                                    <>
                                        {list.list.map((item, index) => (
                                            <div className='carousel_slide' key={index}>
                                                <div className='imageBtns'>
                                                    <button className="editBtn btn btn-primary btn-sm" title="Remove image" onClick={() => showModal(item, "edit")}>
                                                        <Icon.PencilFill />
                                                    </button>
                                                    <button className="deleteBtn btn btn-danger btn-sm" title="Remove image" onClick={() => showModal(item, "delete")}>
                                                        <Icon.TrashFill />
                                                    </button>
                                                </div>
                                                <div className='carousel_slider p-3'>
                                                    <h5>{item?.heading}</h5>
                                                    <span className={`badge text-capitalized ${item?.isActive ? "bg-success" : "bg-danger"}`}>{item?.isActive ? "Active" : "Disabled"}</span>
                                                    <h6 className='mt-3'>{item?.offerAmount} <del style={{ opacity: 0.5 }}>{item?.originalAmount}</del></h6>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>

                    <Modal show={modal.show} centered size='md' onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Heading</strong></label>
                                        <input placeholder="" type="text" name="heading" onChange={handleChange} className="form-control" value={value.heading} />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Offer Amount (RM)</strong></label>
                                        <input placeholder="eg: RM 10" type="text" name="offerAmount" onChange={handleChange} className="form-control" value={value.offerAmount} />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Original Amount (RM)</strong></label>
                                        <input placeholder="eg: RM 15" type="text" name="originalAmount" onChange={handleChange} className="form-control" value={value.originalAmount} />
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this slide.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}

                        </Modal.Body>
                    </Modal>

                </main>
            }
        </>
    )
}
